import InfoDetails from 'components/InfoDetails';
import Separator from 'components/Separator';
import './constructionInfo.scss'

const ConstructionInfo = ({ data }) => {

    const items = [
        {
            title: 'Has Fireplace',
            value: data.has_fireplace ? 'Yes' : 'No',
        },
        {
            title: 'Has Carport',
            value: data.has_carport ? 'Yes' : 'No',
        },
        {
            title: 'Water Access',
            value: data.water_access_yn ? 'Yes' : 'No',
        },
        {
            title: 'Water View',
            value: data.water_view_yn ? 'Yes' : 'No',
        },
    ]

    return (
        <div className='construction-info-container'>
            <div className='details'>
                <p className='header'>Construction Details</p>
                <Separator height={16} />
                <div className='items'>
                    {
                        items.map((item, index) => {
                            return (
                                <div className='item' key={index}>
                                    <p className='title'>{item.title}</p>
                                    <p className='value'>{item.value}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            {
                data.water_access.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Water Access'} items={data.water_access} />
                </>
            }
            {
                data.water_view.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Water View'} items={data.water_view} />
                </>
            }
            {
                data.window_features.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Window Feature'} items={data.window_features} />
                </>
            }
        </div>
    )
}


export default ConstructionInfo;